export class ResortPageViews{
    static ResortAppLoading:string = "ResortApplicationLoading";
    static SearchPage:string = "SearchResorts_PageView";
    static SearchResults:string = "SearchResorts_ResultsPageView";
    static ResortDetailsPreferred: string = "ResortDetailsPreferred_PageView";
    static ResortDetailsStandard: string = "ResortDetailsStandard_PageView";
    static CheckoutPage: string = "Checkout_PageView";
    static ConfirmationPage:string = "Confirmation_PageView";
}

export class SearchEvents{
    static BannerArrowClicked:string = "SearchPage_BannerArrowClicked";
    static BannerSearchClicked:string = "SearchPage_BannerSearchClicked";
    static DestinationEntered:string = "SearchPage_DestinationEntered";
    static DirectSearchInitiated:string = "SearchPage_DirectSearchInitiated";
    static DefaultSearchInitiated:string = "SearchPage_DefaultSearchInitiated";
    static SearchButtonClicked: string = "SearchPage_SearchButtonClicked";
    static SearchFailure: string = "DestinationSearchFailed";
    static SearchResultsReceived:string = "SearchPage_SearchResultsReceived";
    static FilterSleepsSelectionChanged: string = "SearchPage_FilterSleepsSelectionChanged";
    static userSearchFilterModalSelection: string = "SearchPage_FilterModalSelectionChanged";
}

export class SearchResultEvents{
    static ResortImageArrowClicked:string = "SearchResults_ResortImageArrowClicked";
    static ExploreButtonClicked:string = "SearchResults_ExploreButtonClicked";
}

export class ResortDetailsPageEvents{
    static WatchedVideo:string ="ResortDetails_VideoWatched";
    static ResortHeroArrowClicked:string ="ResortDetails_HeroArrowClicked";
    static HeroAvailabilityButtonClicked:string  = "ResortDetails_HeroAvailabilityButtonClicked";
    static NavigationClicked: string = "ResortDetails_NavMenuClicked";
    static ViewFloorPlanClicked: string = "ResortDetails_ViewFloorPlanClicked";
    static CarouselArrowClicked:string = "ResortDetails_CarouselArrowClicked";
    static CarouselBookButtonClicked:string ="ResortDetails_CarouselBookButtonClicked";
    static CarouselAvilabilityButtonClicked:string ="ResortDetails_CarouselAvailabilityButtonClicked";
    static DestinationImageArrowClicked:string = "ResortDetails_DestinationImageArrowClicked";
    static DiningImageArrowClicked:string = "ResortDetails_DiningImageArrowClicked";
    static SpaImageArrowClicked:string ="ResortDetails_SpaImageArrowClicked";
    static ActivitiesImageArrowClicked:string ="ResortDetails_ActivitiesImageArrowClicked";
    static AvailabilityModalDateFilterApplied:string ="ResortDetails_AvailabilityModalDateFilterApplied";
    static AvailabitlityModalResultsFilterApplied:string = "ResortDetails_AvailabilityModalResultsFilterApplied";
    static AvailabitlityModalCloseButtonClicked:string = "ResortDetails_AvailabilityModalCloseButtonClicked";
    static AvailabitlityModalOnBookButtonClicked:string = "ResortDetails_AvailabilityModalOnBookButtonClicked";
    static AvailabitlityModalNearBookButtonClicked: string = "ResortDetails_AvailabilityModalNearBookButtonClicked";
    static ResortDetailFailure: string = "ProductDetailsFailed";
}

export class CheckoutPageEvents{
    static GuestNumberDropDownSelectionMade:string = "CheckoutPage_GuestNumberDropDownSelectionMade";
    static FirstGuestDropDownSelectionMade:string = "CheckoutPage_FirstGuestDropDownSelectionMade";
    static FirstGuestNameUpdated:string = "Checkoutpage_FirstGuestNameUpdated";
    static CardNameUpdated:string = "CheckoutPage_CardNameUpdated";
    static ResortTermsLinkClicked:string = "CheckoutPage_ResortTermsLinkClicked";
    static BillingAddressEditButtonClicked:string = "CheckoutPage_BillingAddressButtonClicked";
    static CompleteBooking: string = "CheckoutPage_CompleteBooking";
    static BookingSuccessful: string = "Checkoutpage_BookingSuccessful";
    static BookingFailure: string = "CheckoutFailed";
    static CountryMissingOrInvalid: string = "Checkoutpage_CountryMissingOrInvalid";
    static InventoryLoadFailure: string = "Checkoutpage_InventoryLoadFailure";
    static PricingInformationLoadFailure: string = "Checkoutpage_PricingInformationLoadFailure";
    static CancellationWaiverDispalyed: string="Checkoutpage_CancellationWaiverPopupDisplayed";
    static CancellationWaiverUserChoice: string = "Checkoutpage_CancellationWaiverPopupUserChoice";
    static CheckoutPageError: string = "Checkoutpage_ErrorDetected";
}

export class ConfirmationPageEvents {
    static ConfirmationFailure: string = "BookingCompletionFailed";
    static ConfirmationSuccess: string = "BookingConfirmationSuccess";

}

export class ResortEventData{
    public partnerId: string;
    public nameId: string;
    public agentId: string;
    public agentName: string;
    public cobrandId:string;
    public certificate:string;
    public authcode:string;
    public cmd: boolean;
    public sessionId: string;

    public initialize(baseData:ResortEventData):void{
        this.partnerId = baseData.partnerId;
        this.agentName = baseData.agentName;
        this.agentId = baseData.agentId;
        this.cobrandId = baseData.cobrandId;
        this.nameId = baseData.nameId;
        this.certificate = baseData.certificate;
        this.authcode = baseData.authcode;
        this.cmd = baseData.cmd;
        this.sessionId = baseData.sessionId;
    }
}

export abstract class ResortInsightsEvent{
    public eventName: string;
    public eventData: ResortEventData;
}

export class SearchPageInsightsEventData extends ResortInsightsEvent{

}

export class ExploreEventData extends ResortEventData{
    public resortId: string;
    public date: Date;
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/instrumentation/resort-custom-events.ts